<!--
 * @Author: liukai
 * @since: 2022-04-19 09:07:25
 * @LastAuthor: liukai
 * @lastTime: 2022-04-21 11:12:55
-->
<template>
  <div >
    <van-popup
        v-model:show="show"
        round
        position="bottom"
        :style="{ height: '300px' }"
        >
        <van-area :visible-item-count="5"  title="标题" :area-list="areaList" :columns-num="2" @cancel="cancel" @confirm="confirm" />
    </van-popup>    
  </div>
</template>

<script>
import { reactive, onMounted, toRefs } from "vue";
import { Popup,Area  } from "vant";
import {getcode} from "@/api/"
export default {
  name: "CityPopup",
  components: {
    [Popup .name]: Popup ,
    [Area.name]:Area,


  },
  setup(props,{emit}) {
    
    const data = reactive({
        show:false,
        areaList: {
            province_list: {
               
            },
            city_list: {
               
            },
            county_list: {
              
            },
        },
        userSelect:[]

    });

    const methodsMap = {
        popUp:()=>{
            data.show=true;
        },
        confirm:(res)=>{
            emit('confirm',res)
            data.show=false;
        },
        cancel:()=>{
            data.show=false;
        },
        requestCode:()=>{
            getcode().then(res=>{
                if(res.data.code==0){
                    data.areaList=res.data.data
                }
            })
        }

    };
    onMounted(()=>{
        methodsMap.requestCode()
    })
    return {
      ...toRefs(data),
      ...methodsMap,
    };
  },
};
</script>

<style lang="scss">

</style>